import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import CategoryNavSection from './components/CategoryNavSection';
import LatestUpdateSection from './components/LatestUpdateSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫网 - 免费韩漫大全 - 热门韩国漫画在线阅读"
        description="韩漫网是免费韩漫大全平台，汇聚热门韩国漫画在线阅读资源，每日更新最新韩漫，免费畅享正版韩漫阅读体验。涵盖恋爱、奇幻、动作、搞笑、悬疑、剧情等多种类型。"
        keywords="韩漫网,免费韩漫大全,热门韩国漫画,在线阅读,韩漫,韩国漫画,免费漫画"
        canonicalUrl="https://hanman.readdy.ai"
        ogType="website"
      />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        name="韩漫网首页 - 免费韩漫大全"
        description="韩漫网是免费韩漫大全平台，汇聚热门韩国漫画在线阅读资源"
        url="https://hanman.readdy.ai"
      />

      <main>
        <HeroSection />
        <HotRecommendSection />
        <CategoryNavSection />
        <LatestUpdateSection />
        <RankingSection />
        <FAQSection />
      </main>
    </>
  );
}